import React from 'react';
import { useGroupState } from './GroupContext';

import styles from './GroupName.module.scss';

const GroupName = () => {
  const state = useGroupState();

  if (state?.loading) {
    return (
      <section id={styles.groupNameSection}>
        <div id={styles.groupNameLoading} />
      </section>
    );
  }

  return (
    <section id={styles.groupNameSection}>
      <h1 id={styles.groupName}>{state?.group?.name}</h1>
    </section>
  );
};

export default GroupName;
